export default "__VITE_ASSET__37b96563__"